<template>
  <div>
    <div class="text-subtitle mb-4">Modifier les informations des activités.</div>
    <div v-if="data_loaded">
      <div v-if="list_activites.list.length === 0" class="text-body-1 text-medium-emphasis mb-4">Aucune activité configurée pour ce module.</div>
      <ActiviteItem v-for="activite in list_activites.list" :key="activite.id" :item="activite"></ActiviteItem>
    </div>

    <v-row>
      <v-col>
        <v-btn color="primary-dark" @click="update_config()" :loading="loading" class="mt-4" block>Enregistrer les modifications</v-btn>
      </v-col>
    </v-row>
    <div v-if="mainStore.authAdmin.isSportipsAdmin">
      <hr />
      <div class="text-h6">Historique des modifications</div>
      <ConfigHistory v-if="list_activites.id_module" action="config_activites" :id="list_activites.id_module" :key="lastFetch"></ConfigHistory>
    </div>
    <v-snackbar v-model="show_snackbar" location="top right" color="dark-green">
      Mise à jour effectuée avec succès !
      <template v-slot:actions>
        <v-btn color="white" variant="text" @click="show_snackbar = false"> Fermer </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import List_Activites from "@/classes/Activites/List_Activites.class";
import ConfigHistory from "@/components/Administration/ConfigurationModule/ConfigHistory.vue";
import ActiviteItem from "@/components/Administration/ConfigurationModule/Config_Activites/Activite_Item.vue";

export default {
  components: { ConfigHistory, ActiviteItem },
  data() {
    return {
      list_activites: new List_Activites(),
      data_loaded: false,
      loading: false,
      show_snackbar: false,
      lastFetch: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async update_config() {
      this.loading = true;
      await this.list_activites.update_config();
      this.loading = false;
      this.show_snackbar = true;
      this.lastFetch = this.$moment().format("YYYY-MM-DD HH:mm:ss");
    },
  },
  async mounted() {
    this.list_activites.id_module = this.mainStore.module.id;
    await this.list_activites.fetch_all();
    this.data_loaded = true;
  },
};
</script>

<style lang="sass" scoped></style>
